{
  "nm": "Main Scene",
  "ddd": 0,
  "h": 520,
  "w": 520,
  "meta": { "g": "@lottiefiles/creator 1.65.2" },
  "layers": [
    {
      "ty": 4,
      "nm": "Checklist",
      "sr": 1,
      "st": 0,
      "op": 720,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [297.587, 298.119, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [259.587, 260.119, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [100], "t": 50 },
            { "s": [0], "t": 62 }
          ],
          "ix": 11
        }
      },
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 2,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": false,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [54.754, -36.121],
                    [-17.487, 36.12],
                    [-54.754, -1.147]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 2,
              "lj": 2,
              "ml": 1,
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 23, "ix": 5 },
              "c": { "a": 0, "k": [1, 1, 1], "ix": 3 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [294.971, 298.679], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "tm",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Filter - Trim",
          "nm": "Trim Paths 1",
          "ix": 2,
          "e": { "a": 0, "k": 100, "ix": 2 },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "s": {
            "a": 1,
            "k": [
              { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0, "y": 1 }, "s": [100], "t": 24 },
              { "s": [0], "t": 36 }
            ],
            "ix": 1
          },
          "m": 1
        }
      ],
      "ind": 1
    },
    {
      "ty": 4,
      "nm": "Cricle",
      "sr": 1,
      "st": 0,
      "op": 720,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [-7.627, -7.691, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [124.222, 124.222, 100],
              "t": 18
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [134.222, 134.222, 100],
              "t": 20
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [114.222, 114.222, 100],
              "t": 22
            },
            { "s": [124.222, 124.222, 100], "t": 24 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [260, 260, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [100], "t": 50 },
            { "s": [0], "t": 62 }
          ],
          "ix": 11
        }
      },
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Ellipse 1",
          "ix": 1,
          "cix": 2,
          "np": 4,
          "it": [
            {
              "ty": "el",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Ellipse",
              "nm": "Ellipse Path 1",
              "d": 1,
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "s": { "a": 0, "k": [178.46, 178.46], "ix": 2 }
            },
            {
              "ty": "tm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Trim",
              "nm": "Trim Paths 1",
              "ix": 2,
              "e": {
                "a": 1,
                "k": [
                  { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.239, "y": 1 }, "s": [0], "t": 0 },
                  { "s": [100], "t": 24 }
                ],
                "ix": 2
              },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "s": { "a": 0, "k": 0, "ix": 1 },
              "m": 1
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 2,
              "lj": 2,
              "ml": 1,
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 10, "ix": 5 },
              "c": { "a": 0, "k": [0.1608, 0.0667, 0.502], "ix": 3 }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1608, 0.0667, 0.502], "ix": 4 },
              "r": 1,
              "o": {
                "a": 1,
                "k": [
                  { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0, "y": 1 }, "s": [0], "t": 22 },
                  { "s": [100], "t": 24 }
                ],
                "ix": 5
              }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [-7.627, -7.691], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 2
    },
    {
      "ty": 4,
      "nm": "Line",
      "sr": 1,
      "st": 0,
      "op": 720,
      "ip": 28,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [298, 298, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0, "y": 1 }, "s": [46, 46, 100], "t": 28 },
            { "s": [100, 100, 100], "t": 50 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [260.38355848524304, 259.90057373046875], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 28 },
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [100], "t": 39 },
            { "s": [0], "t": 50 }
          ],
          "ix": 11
        }
      },
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 2,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [-120.208, 0],
                    [0, -120.208],
                    [120.207, 0],
                    [0, 120.208]
                  ],
                  "o": [
                    [120.207, 0],
                    [0, 120.208],
                    [-120.208, 0],
                    [0, -120.208]
                  ],
                  "v": [
                    [0, -217.655],
                    [217.655, 0],
                    [0, 217.655],
                    [-217.655, 0]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "c": { "a": 0, "k": [0.1608, 0.0667, 0.502], "ix": 3 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [297.587, 298.119], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 3
    },
    {
      "ty": 4,
      "nm": "Shadow",
      "sr": 1,
      "st": 0,
      "op": 720,
      "ip": 22,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [298, 298, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0, "y": 1 }, "s": [60, 60, 100], "t": 22 },
            { "s": [100, 100, 100], "t": 44 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [260, 260, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 22 },
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [100], "t": 33 },
            { "s": [0], "t": 44 }
          ],
          "ix": 11
        }
      },
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 2,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [-94.797, 0],
                    [0, -94.797],
                    [94.797, 0],
                    [0, 94.798]
                  ],
                  "o": [
                    [94.797, 0],
                    [0, 94.798],
                    [-94.797, 0],
                    [0, -94.797]
                  ],
                  "v": [
                    [0, -171.646],
                    [171.646, 0],
                    [0, 171.646],
                    [-171.646, 0]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1608, 0.0667, 0.502], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [297.587, 298.119], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 4
    }
  ],
  "v": "5.7.0",
  "fr": 24,
  "op": 63,
  "ip": 0,
  "assets": []
}
